<template>
  <modal

    name="csv-upload-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
    @before-open="getData"
   
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50" v-text="modal_type" v-if="modalTypeTargeted"></p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="mb-2">
            <p class="txt--xs txt--off-white d-flex justify-content-between">
              <span>CSV Upload</span>
             
              <a :href="sample_link" download 
                 class="        
                    text-center
                    d-flex
                    justify-content-center
                    mt-2
                    download-btn
                  ">Download Sample CSV
                  <span class="ml-2">
                    <i class="fas fa-cloud-download-alt"></i>
                  </span>
              </a>
            </p>
          </div>
          <div class="upload">
            <div
              class="h-100 d-flex align-items-center justify-content-center"
              id="app"
            >
              <div
                class="w-100 h-100 d-flex align-items-center justify-content-center align-items-center"
                @dragover="dragover"
                @dragleave="dragleave"
                @drop="drop"
              >
                <input
                  type="file"
                  multiple
                  name="fields[assetsFieldHandle][]"
                  id="assetsFieldHandle"
                  class=""
                  @change="onChange"
                  ref="file"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />

                <label for="assetsFieldHandle" class="block cursor-pointer">
                  <div class="text-center txt--xs txt--off-white">
                    drop files in here <br />or<br />
                    <span class="underline font-weight-bold">Browse</span>
                  </div>
                </label>
            
                
              </div>
            </div>
          </div>
          <div class="container p-0" v-if="filelist.length" >
            <ul class="mt-4 row" v-if="filelist.length" v-cloak>
              <li class="col-auto mb-2" v-for="(file,index) in filelist" :key="index" >
                <span class="d-flex align-items-center badge badge-dark px-2 py-2">
                  <span style="font-size: 11px">{{ file.name }}</span>
                  <span  @click="remove(index)" class="ml-2 cursor-pointer" style="font-size: 10px">
                    <i class="fas fa-trash txt--red" aria-hidden="true"></i>
                  </span>
                </span>
                  
                
                <!--  <button
                  class="ml-2 mt-2 button button--primary button--sm mr-3"
                  type="button"
                  @click="remove(index)"
                  title="Remove file"
                >
                  remove
                </button> -->
                  
              </li>
            </ul>
          </div>
            
        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner class="button button--primary button--sm mr-3"
          @click="uploadCSV()"
          :disabled="create_button.disabled"
          :loading="create_button.loading"
          :success="create_button.success"
        >
          Done</ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
// import { ModelSelect, ModelListSelect } from "vue-search-select";
import ButtonWithSpinner from "@/components/Button";
// import Toggle from "@/components/toggle";
export default {
  name: "CsvUpload",
  components: {
    // AppToggle: Toggle,
    // ModelListSelect,
    // ModelSelect,
    ButtonWithSpinner,
  },
  props:[''],
  data() {
    return {
      value: null,
      options: ["list", "of", "options"],
      unlimited_validaiton: true,
      filelist: [], // Store our uploaded files
      csv_name:'',
      modal_type:'',
      upload_url:'',
      modalTypeTargeted:'',
      sample_link:'',
      create_button: {
        disabled: false,
        loading: false,
        success: false,
      },
    };
  },

  created() {
      
  },
  watch: { 
    
  },
  methods: {

    getData(e){

      this.modalTypeTargeted = e.params.modalTypeTargeted;

      if(this.modalTypeTargeted == 'operator'){
        this.modal_type = "Operator CSV Upload";
        this.upload_url = "/api/auth/operator/add-operator-from-csv";
        this.sample_link = "Sample/SampleOperatorList.csv";
      }
      else if(this.modalTypeTargeted == 'role'){
        this.modal_type = "Role CSV Upload";
        this.upload_url = "/api/auth/role/add-roles-from-csv";
        this.sample_link = "Sample/SampleRoleList.csv";
      }
      else if(this.modalTypeTargeted == 'department'){
        this.modal_type = "Department CSV Upload";
        this.upload_url = "/api/auth/departments/add-departments-from-csv";
        this.sample_link = "Sample/SampleDepartmentList.csv";
      }
      else{
        this.$toasted.show("Something went wrong. Please try again!", {
                icon: "times-circle",
                className: "error-class",
              });
        return;
      }
     
    },
    refresh(){
      this.modal_type='';
      this.upload_url='';
      this.modalTypeTargeted='';
      this.filelist=[];
      this.create_button.disabled =false;
      this.create_button.loading  =false;
      this.create_button.success =false;    
    },
    closeModal() {
      this.refresh();
      this.$modal.hide("csv-upload-modal");
    },
    onChange() {   
      this.filelist = [...this.$refs.file.files];
      console.log(this.filelist[0].size);
    },
    remove(i) {
      this.filelist.splice(i, 1);
      console.log(this.filelist);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    AsyncButtonLoaderSuccessReset(flag_file_count){
     
      if(flag_file_count>0){
        return;
      }
      this.create_button.disabled = false;
      this.create_button.success = true;
      this.create_button.loading = false;
      this.closeModal();
      this.$emit("update_list");
    },
    AsyncButtonLoaderErrorReset(flag_file_count){
       if(flag_file_count>0){
        return;
       }
       this.create_button.disabled = false;
       this.create_button.success = false;
       this.create_button.loading = false;
    },
    uploadCSV() {

      if(this.filelist.length == 0){
        this.$toasted.show("Please select a csv file!", {
              icon: "times-circle",
              className: "error-class",
            });
            return;
      }

      let mimes = [
        "text/comma-separated-values",
        "text/csv",
        "application/csv",
        "application/excel",
        "application/vnd.ms-excel",
        "application/vnd.msexcel",
        "text/anytext",
        "csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ""
      ];
      let flag_file_count=this.filelist.length;
      this.create_button.loading = true;
      this.create_button.disabled = true;
      this.create_button.success = false;
      // console.log(event.target.files[0].type);
      for (var i=0;i<this.filelist.length;i++ )
      {
    
          if (
            this.filelist.length > 0 &&
            mimes.indexOf(this.filelist[i].type) != -1
          ) {
            if (this.filelist[i].size <= 5 * 1024 * 1024) {
              // 5MB
              this.csv_name = this.filelist[i].name;
              this.csv_name = this.csv_name.split(".csv")[0];

              this.formData = new FormData();
              this.formData.append("csv", this.filelist[i]);
              this.csv_uploading = true;

              
              this.axios
                .post(
                  window.hostname + this.upload_url,
                  this.formData
                )
                .then((res) => {
                  if (res.data.status) {
                    this.$toasted.show(res.data.message, {
                      icon: "check-circle",
                      className: "success-class",
                    });
                    this.csv_name = "";
                    flag_file_count--;
                    this.AsyncButtonLoaderSuccessReset(flag_file_count);
                   
                
                  } else {
                    this.$toasted.show(res.data.message, {
                      icon: "times-circle",
                      className: "error-class",
                    });
                    this.csv_name = "";   
                    flag_file_count--;
                    this. AsyncButtonLoaderErrorReset(flag_file_count);           
                  }
                  this.csv_uploading = false;
                })
                .catch((err) => {
                  this.csv_name = "";
                  this.csv_uploading = false;
                
                  this.$toasted.show("Something went wrong. Please try again!", {
                    icon: "times-circle",
                    className: "error-class",
                  });
                  flag_file_count--;
                  this. AsyncButtonLoaderErrorReset(flag_file_count);  
                });
            } else {
              this.$toasted.show("CSV file size can not exceed 5MB!", {
                icon: "times-circle",
                className: "error-class",
              });
              this.csv_name = "";
              flag_file_count--;
              this. AsyncButtonLoaderErrorReset(flag_file_count);  
            
            }
          } else {
            this.$toasted.show("Please upload a valid CSV file!", {
              icon: "times-circle",
              className: "error-class",
            });
            this.csv_name = "";
            flag_file_count--;
            this. AsyncButtonLoaderErrorReset(flag_file_count);  
          
          }

      }
    
    },
  },
};
</script>

<style scoped>
.download-btn {
  background: transparent;
  border: none;
  outline: none;
  color: #cc8c1f;
}
.upload {
  border: 1px dashed #8c8c8c;
  height: 100px;
  border-radius: 10px;
}
.underline {
  color: #cc8c1f;
}
[v-cloak] {
  display: none;
}
</style>